<template>
  <AppView title="關於我們" :backable="true">
    <main class="min-w-0 bg-white desk:min-h-0 desk:flex-1">
      <div class="min-w-0 desk:grid desk:grid-cols-2 desk:items-start">
        <section class="min-w-0 desk:border-r desk:border-gray-100 desk:px-12 desk:py-10">
          <p class="hidden text-xs font-medium text-gray-400 desk:block desk:text-dove-gray">門市資訊</p>
          <h2
            class="my-5 text-center text-xl font-bold tracking-wider desk:mb-6 desk:mt-2 desk:text-left desk:text-2xl desk:tracking-normal desk:text-gray-900"
          >
            營業時間
          </h2>
          <div class="mb-5 text-center desk:mb-8 desk:text-left">
            <div class="px-5 desk:px-0">
              <div v-if="imgs.opening_hours" class="mb-3">
                <img
                  :src="imgs.opening_hours"
                  alt="營業時間"
                  class="desk:block desk:h-auto desk:w-full"
                />
              </div>
              <p v-else class="text-sm text-gray-400">暫無營業時間資料</p>
            </div>
          </div>

          <hr class="m-5 desk:hidden" />

          <div class="mb-5 text-center desk:mb-0 desk:text-left">
            <div class="px-5 desk:px-0">
              <div v-if="imgs.about" class="mb-3">
                <img
                  :src="imgs.about"
                  alt="關於我們"
                  class="desk:block desk:h-auto desk:w-full"
                />
              </div>
              <p
                v-if="info.address"
                class="mb-3 text-sm tracking-wider text-chicago desk:break-words desk:leading-6 desk:tracking-normal"
              >
                {{ info.address }}
              </p>
            </div>
          </div>
        </section>

        <section class="min-w-0 desk:px-12 desk:py-10">
          <hr class="m-5 desk:hidden" />

          <h2
            class="mb-5 text-center text-xl font-bold tracking-wider desk:mb-6 desk:mt-0 desk:text-left desk:text-2xl desk:tracking-normal desk:text-gray-900"
          >
            公司簡介
          </h2>
          <div class="px-5 desk:px-0">
            <div class="tracking-wider desk:tracking-normal">
              <img
                v-if="imgs.shop"
                class="mb-3 w-full desk:mb-6 desk:h-auto"
                :src="imgs.shop"
                alt="店舖照片"
              />
              <h3
                v-if="info.about?.title"
                class="mb-2 font-bold text-primary desk:mb-3 desk:text-xl"
              >
                {{ info.about.title }}
              </h3>
              <div
                v-if="info.about?.content"
                class="mb-3 text-sm text-chicago desk:mb-0 desk:break-words desk:leading-7"
                v-html="info.about.content"
              />
              <p
                v-else-if="!imgs.shop && !info.about?.title"
                class="mb-3 text-sm text-gray-400"
              >
                暫無公司簡介
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  </AppView>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  auth: false,

  computed: {
    ...mapGetters({
      imgs: "app/imgs",
      info: "app/info",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
